const HomeIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18 19V10L20 8H4V21C4 21.3 4.06 21.59 4.14 21.86C4.41 21.94 4.7 22 5 22C6.66 22 8 20.66 8 19V16H12L14 18V21C14 21.3 14.06 21.59 14.14 21.86C14.41 21.94 14.7 22 15 22C16.66 22 18 20.66 18 19Z"
            fill="#E5E5E5"
        />
        <g opacity="0.6">
            <path
                d="M6.14 23.86C6.06 23.59 6 23.3 6 23V10H20V8H4V21C4 21.3 4.06 21.59 4.14 21.86C4.43 22.82 5.18 23.58 6.14 23.87V23.86Z"
                fill="white"
            />
        </g>
        <path
            d="M7.99989 16V19C7.99989 20.66 6.65989 22 4.99989 22C4.69989 22 4.40989 21.94 4.13989 21.86C4.50989 23.09 5.63989 24 6.99989 24C8.65989 24 9.99989 22.66 9.99989 21V18H13.9999L15.9999 16H7.99989Z"
            fill="#CBCBCB"
        />
        <path
            d="M18 12V19C18 20.66 16.66 22 15 22C14.7 22 14.41 21.94 14.14 21.86C14.51 23.09 15.64 24 17 24C18.66 24 20 22.66 20 21V10H4L18 12Z"
            fill="#CBCBCB"
        />
        <path
            d="M21.0801 8.2598L20.3001 7.5498C20.6201 8.1698 20.2001 8.9998 19.4101 8.9998H2.59009C2.59009 9.5098 2.98009 9.9998 3.58009 9.9998H20.4101C21.3201 9.9998 21.7601 8.8798 21.0801 8.2598Z"
            fill="#6C000D"
        />
        <path
            d="M14.3401 2.21989L20.3501 7.67989C20.3501 7.67989 20.3201 7.58989 20.3001 7.54989L13.3401 1.21989C12.5801 0.529893 11.4101 0.529893 10.6501 1.21989L2.91009 8.25989C2.68009 8.46989 2.59009 8.73989 2.59009 8.99989H4.20009L11.6501 2.21989C12.4101 1.52989 13.5801 1.52989 14.3401 2.21989Z"
            fill="#C5404C"
        />
        <path
            d="M20.3502 7.67989L14.3402 2.21989C13.5802 1.52989 12.4102 1.52989 11.6502 2.21989L4.2002 8.99989H19.4102C20.1402 8.99989 20.5502 8.28989 20.3502 7.67989Z"
            fill="#BB1E2D"
        />
    </svg>
)

HomeIcon.displayName = 'HomeIcon'

export default HomeIcon
